import React from 'react'
import Introduction from './components/Introduction'
import Navbar from './components/Navbar'
import Projects from './components/Projects'
import Bio from './components/Bio'
import Skills from './components/Skills'
// import Experience from './components/Experience'
import ContactForm from './components/Contact'
import Footer from './components/Footer'

const App = () => {
  return (
    <div className="relative min-h-screen bg-[#FDFBF7] text-stone-800 antialiased dark:bg-zinc-900 dark:text-stone-300 transition-colors duration-500 overflow-x-hidden">
      {/* Calm gradient background decorations */}
      <div className="fixed top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-orange-100/40 blur-[120px] dark:bg-stone-800/40 -z-10 pointer-events-none"></div>
      <div className="fixed bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-stone-200/40 blur-[120px] dark:bg-zinc-800/40 -z-10 pointer-events-none"></div>
        
      <div className="relative z-10 flex flex-col items-center px-6 py-8 space-y-24 lg:space-y-32 container mx-auto max-w-5xl">
        <Navbar />
        <Introduction />
        <Bio />
        <Skills />
        {/* <Experience /> */}
        <Projects />
        <ContactForm />
        <Footer />
      </div>
    </div>
  )
}

export default App
